import { MaterialReactTable } from "material-react-table";
import { Button, Card, CardBody, Row } from "reactstrap";
import { MenuItem } from "@mui/material";
import { handleAddToOrder, handleSaveOrder, removeSubscription } from "./constants/HandleReasonChange";
import { useState } from "react";


export const TableDataForViewCancel = ({isCancel,isView,showSaveButton,OrderID,orderID,allOrderData,dispatch,setLoading,navigate,setDisplayButton,state,setCreateOrderButton,CustomerId,stateArray,viewColumns,columns,offerDataOfOrder,setTaxAmount,setTotalAmountWithTax,setOrderID}) => {

    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });

    return (
        <div>
        <div>
            {(!isView && !isCancel) && <div className="d-flex justify-content-end align-items-center mb-2">
                {!showSaveButton && (OrderID !== "" || orderID !== "") && (
                    <Button className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap mx-1" onClick={()=>handleSaveOrder(allOrderData, dispatch, setLoading, OrderID, navigate, "Create", setDisplayButton, state, setCreateOrderButton,setTaxAmount,setTotalAmountWithTax,setOrderID)}>
                        <i class="ri-save-line label-icon align-middle fs-16 me-1 fw-bold"></i>
                        <span className="ps-2 ms-2 me-1 fw-bold">
                            {"Save"}    
                        </span> 
                    </Button>
                )}
                <Button className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap mx-1" onClick={()=>handleAddToOrder( stateArray, setCreateOrderButton, navigate, CustomerId, orderID)}>
                    <i className="ri-add-fill label-icon align-middle fs-16 me-1 fw-bold"></i>
                    <span className="ps-2 ms-2 me-1 fw-bold">
                      {"Add"}
                    </span>
                </Button>
            </div>}
            <Row className="mb-3 mt-1 table-responsive">
                {allOrderData ? (
                    <MaterialReactTable
                        columns={(isView || isCancel) ? viewColumns : columns}
                        data={(isView || isCancel) ? offerDataOfOrder : allOrderData.slice(
                                pagination.pageIndex * pagination.pageSize, 
                                (pagination.pageIndex + 1) * pagination.pageSize
                            )}
                        enableColumnOrdering={false}
                        enableColumnDragging={false}
                        enableDensityToggle={false}
                        enableColumnActions={true}
                        enableTopToolbar={false}
                        muiTableHeadCellProps={{
                            sx: {
                                fontFamily: "Inter,sans-serif"
                            }
                        }}
                        muiTableBodyCellProps={{
                            sx: {
                                fontFamily: "Inter,sans-serif"
                            }
                        }}
                        enableRowActions={(isView || isCancel) ? false : true}
                        displayColumnDefOptions={{
                            'mrt-row-actions': {
                                header: '',
                                enableHiding: true
                            }
                        }}
                        manualPagination
                        rowCount={allOrderData.length} 
                        state={{ pagination }}
                        onPaginationChange={(updater) => {
                            setPagination((prev) => {
                                const newPagination = typeof updater === "function" ? updater(prev) : updater;
                                return { ...prev, ...newPagination }; 
                            });
                        }}
                        renderRowActionMenuItems={({ closeMenu, row }) => {
                            if (!isView) {
                                return [
                                    <MenuItem
                                        className='row-options'
                                        key={row.index}
                                        onClick={() => {
                                            removeSubscription(row.original.subscriptionID,dispatch)
                                            closeMenu();
                                        }}
                                    >
                                        <i className="ri ri-delete-bin-5-line me-2 text-danger" />
                                        Delete
                                    </MenuItem>,
                                ]
                            }
                        }}
                    />
                ) : null}
            </Row>
        </div>
    </div>
    )
}